import { FC } from 'react';

import { useTranslation } from 'next-i18next';
import getClassNames from 'src/common/utils/getClassNames';
import getListingCountPaginationSummary from 'src/common/utils/getListingCountPaginationSummary';

import useFeatureFlag from 'src/common/hooks/useFeatureFlag';
import styles from './ListingPaginationSummary.module.scss';

export type ListingPaginationSummaryProps = {
  limit: number;
  count: number;
  page?: number;
  rounded: boolean;
  classNameModifier?: string;
};

const ListingPaginationSummary: FC<ListingPaginationSummaryProps> = ({
  limit,
  count,
  page,
  rounded,
  classNameModifier,
}) => {
  const [t] = useTranslation('common');
  const isNavUpdateEnabled = useFeatureFlag('pricing-v2--nav');
  const { key, interpolationOptions } = getListingCountPaginationSummary({
    limit,
    count,
    page,
    rounded,
    isNavUpdateEnabled,
  });

  return (
    <h6 className={getClassNames(styles, 'root', classNameModifier)}>
      {t(key, interpolationOptions)}
    </h6>
  );
};

export default ListingPaginationSummary;
